import React, { Component } from "react";
import { Input, Modal, Button, Form, Tooltip } from 'antd';
import { NodeIndexOutlined, } from '@ant-design/icons';


class EntryRelations extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            method: null,
            event: null,
            values: null,
        };
    }
    componentDidUpdate(prevProps, prevState) {
        let activeElement = this.props.activeElement
        if (activeElement && activeElement.type === 'bpmn:ServiceTask' && !this.state.visible && activeElement.businessObject.delegateExpression === "${entryRelations}") {//Change
            let value = {};
            let inputParameters = null;
            if (this.props.activeElement.businessObject.extensionElements) {
                inputParameters = this.props.activeElement.businessObject.extensionElements.values[0].inputParameters;
            }
            inputParameters.forEach((el) => value[el.name] = el.value);
            this.setState({
                values: value,
                visible: true
            })
        }
    }
    handleCancel = () => {
        this.setState({ visible: false, values: null });
        this.props.clearElement()
    }
    showModal = (event) => {
        this.setState({
            visible: true,
            event: event
        });
    }
    method = (value) => {
        this.setState({
            method: value
        })
    }

    createTask = (value) => {
        const modeling = this.props.modeler.get('modeling');
        const bpmnFactory = this.props.modeler.get("bpmnFactory");
        const elementFactory = this.props.modeler.get("elementFactory");
        const create = this.props.modeler.get("create");
        let selection = this.props.modeler.get('selection');

        let ServiceTask = bpmnFactory.create('bpmn:ServiceTask');
        ServiceTask.definitionRef = 'modelerTemplate';
        ServiceTask.modelerTemplate = "com.aphinit.bpmn.delegate.EntryRelations";//Change
        ServiceTask.delegateExpression = "${entryRelations}";//Change

        let entryId = bpmnFactory.create('camunda:InputParameter', {
            name: "entryRelations_EntryId",
            value: value.entryRelations_EntryId
        });
        let nameVariable = bpmnFactory.create('camunda:InputParameter', {
            name: "entryRelations_RelationsVariableName",
            value: value.entryRelations_RelationsVariableName
        });

        let inputOutput = bpmnFactory.create('camunda:InputOutput', {
            inputParameters: [entryId, nameVariable],
            outputParameters: []
        });
        const extensionElements = bpmnFactory.create("bpmn:ExtensionElements");
        extensionElements.set("values", [inputOutput]);
        const serviceTask = elementFactory.createShape({
            type: "bpmn:ServiceTask",
            x: this.state.values ? this.props.activeElement.x + 50 : 0,
            y: this.state.values ? this.props.activeElement.y + 40 : 0,
            isExpanded: true,
            businessObject: ServiceTask
        });
        serviceTask.businessObject.set('name', "Entry relations");
        serviceTask.businessObject.set("extensionElements", extensionElements);
        if (this.state.values) {
            let newElement = modeling.replaceShape(this.props.activeElement, serviceTask);
            selection.select(newElement);
            this.props.clearElement();
        }
        else {
            create.start(this.state.event, [serviceTask], {
                hints: {
                    autoSelect: [serviceTask]
                }
            });
        }
        this.setState({
            visible: false, values: null
        });
    };


    render() {
        let modal = <Modal title="Entry relations" destroyOnClose={true} open={this.state.visible} footer={false} onCancel={this.handleCancel} >
            <Form name="dynamic_form_nest_item" layout="vertical" onFinish={this.createTask} autoComplete="off" initialValues={this.state.values}>
                <Form.Item
                    name='entryRelations_EntryId'
                    label='Entry ID'
                    rules={[
                        {
                            required: true,
                            message: 'Missing Entry ID',
                        },
                    ]}
                >
                    <Input />
                </Form.Item>
                <Form.Item
                    name='entryRelations_RelationsVariableName'
                    label='Relations - variable name'
                    help='Get relations map collection'
                    rules={[
                        {
                            required: true,
                            message: 'Missing variable name',
                        },
                    ]}
                >
                    <Input />
                </Form.Item>

                <div style={{ display: 'flex', justifyContent: 'end', }}>
                    <Button type="default" onClick={this.handleCancel} style={{ marginRight: '10px' }} >
                        Cancel
                    </Button>
                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Ok
                        </Button>
                    </Form.Item>
                </div>
            </Form>
        </Modal>
        return <>{modal}<Tooltip placement="rightTop" title="Entry relations">
            <NodeIndexOutlined onClick={(event) => this.showModal(event)} style={{ fontSize: '22px', marginLeft: '3px' }} />
        </Tooltip>
        </>
    }
}

export default EntryRelations;